import { render, staticRenderFns } from "./DayTypeTable.vue?vue&type=template&id=42638ccc"
import script from "./DayTypeTable.vue?vue&type=script&lang=js"
export * from "./DayTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports